import { Shield } from 'lucide-react';
import { cn } from '../utils/cn';

interface ShowAutoModToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  hiddenCount: number;
  className?: string;
}

export function ShowAutoModToggle({ checked, onChange, hiddenCount, className }: ShowAutoModToggleProps) {
  if (hiddenCount === 0 && !checked) return null;

  return (
    <label
      className={cn(
        'inline-flex items-center gap-2 text-sm text-glass-400 cursor-pointer whitespace-nowrap select-none',
        className,
      )}
    >
      <span className="switch">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          aria-label="Show AutoMod"
        />
        <span />
      </span>
      <Shield className="w-4 h-4 text-amber-400" />
      <span>
        Show AutoMod
        {hiddenCount > 0 && !checked && (
          <span className="ml-1 text-amber-400/80 tabular-nums">({hiddenCount} hidden)</span>
        )}
      </span>
    </label>
  );
}
